import { Injectable, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';

export enum BreakpointView {
    Small = 0,
    Middle = 1,
    Full = 2
}

@Injectable()
export class SmallScreenSheetModalContainerService {
    private favoriteElementsCount: BreakpointView = 0;

    public broadcastTriggerCalculateBreakpoint$: Subject<number> = new Subject<number>();

    public headerTemplate$ = new Subject<TemplateRef<any>>();

    /* Methods */
    public setFavoriteElementsCount(value: BreakpointView): void {
        this.favoriteElementsCount = value;
    }

    public triggerCalculateBreakpoint(): void {
        this.broadcastTriggerCalculateBreakpoint$.next(
            this.favoriteElementsCount ? BreakpointView.Middle : BreakpointView.Small
        );
    }

    public setHeaderTemplate(template: TemplateRef<any> | null) {
        this.headerTemplate$.next(template);
    }
}
